<template>
    <span>
    </span>
</template>

<script>

export default {
    name: 'StoreInit',
    props: {
        data: {
            default: {}
        }
    },
    computed: {
        
    },
    created() {
        this.$store.dispatch('doInitStore', this.data)
    },
    mounted() {

    },
    methods: {

    },
    components:{
		
    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// assets/js/vue/components/StoreInit.vue